import logEvent from '../logEvent';

export const MESSAGE_REQUIRED_ERROR = 'Message is required for js_unexpected.';

type props = { appName?: string, [key: string]: unknown } | string;

/**
 * Logs an event when JS logic ends in an unexpected state.
 *
 * @param {string} message Message to be logged.
 * @param {Object} [properties={}] Additional event properties.
 */
export default function logJsUnexpected(message: string, properties: props = {}): void {
  if (!message) {
    throw Error(MESSAGE_REQUIRED_ERROR);
  }

  let body: Record<string, unknown> = { message };
  if (typeof properties === 'string') {
    body.details = properties;
  } else {
    body = { ...body, ...properties };
  }

  logEvent('js_unexpected', body);
}
